import { Layer } from 'modules/shares/types'

const isTintLayer = ({ style, type }: Layer): boolean =>
  !!style?.fills?.filter(fill => fill.isEnabled).length && type === 'group'

const isExportLayer = (layer: Layer): boolean => !!layer.exportFormats?.length

const isOpacityLayer = (layer: Layer): boolean =>
  (layer.style?.appearance?.opacity ?? 1) < 1

export const hasParentLayerWithTint = (
  layers: Record<string, Layer>,
  currentLayer: Layer
): boolean => {
  // Both layer list and current layer with parent are required
  if (!layers || !Object.keys(layers || {}).length || !currentLayer?.parent) {
    return false
  }

  const parentLayer = layers[currentLayer.parent as string]

  return isTintLayer(parentLayer) || hasParentLayerWithTint(layers, parentLayer)
}

export const hasParentLayerWithExports = (
  layers: Record<string, Layer>,
  currentLayer: Layer
): boolean => {
  // Both layer list and current layer with parent are required
  if (!layers || !Object.keys(layers || {}).length || !currentLayer?.parent) {
    return false
  }

  const parentLayer = layers[currentLayer.parent as string]

  return (
    isExportLayer(parentLayer) || hasParentLayerWithExports(layers, parentLayer)
  )
}

export const hasParentLayerWithOpacity = (
  layers: Record<string, Layer>,
  currentLayer: Layer
): boolean => {
  // Both layer list and current layer with parent are required
  if (!layers || !Object.keys(layers || {}).length || !currentLayer?.parent) {
    return false
  }

  const parentLayer = layers[currentLayer.parent as string]

  return (
    isOpacityLayer(parentLayer) ||
    hasParentLayerWithOpacity(layers, parentLayer)
  )
}
